import { CustomButton } from "@/utils/buttons/custom-button";

export class CustomButtonWrapper {
	Browse1: CustomButton[] = [];
	Browse2: CustomButton[] = [];
	Browse3: CustomButton[] = [];
	Browse4: CustomButton[] = [];
	Browse5: CustomButton[] = [];
	Browse6: CustomButton[] = [];
	Browse7: CustomButton[] = [];
	Browse8: CustomButton[] = [];
	Browse9: CustomButton[] = [];
	Browse10: CustomButton[] = [];
	Browse11: CustomButton[] = [];
	Browse12: CustomButton[] = [];
	Browse23: CustomButton[] = [];

	public constructor(data?: any) {
		if (!data) return;
		for (let key of Object.keys(data)) {
			if (Array.isArray(data[key])) {
				(this as any)[key] = data[key].map((c: CustomButton) => new CustomButton(c));
			}
		}
	}

	public getJSON() {
		let result: {[key: string]: CustomButton[]} = {};
		for (let key of Object.keys(this)) {
			if (Array.isArray((this as any)[key])) {
				result[key] = (this as any)[key];
			}
		}
		return result;
	}

	public getButtonsForBrowse(browseId: number): CustomButton[] {
		if (!(this as any)["Browse" + browseId]) return [];
		return (this as any)["Browse" + browseId];
	}
}
